import styled from 'styled-components';

export const UserProfileWrapper = styled.div`
  background-color: ${props => props.color};
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
`;



// WEBPACK FOOTER //
// ./src/routes/UserProfile/components/styles.js